import { BASE_SERVICE_URL } from '../../../lib/constants'
import type SFTP from '../interface/sftpIntegration';

const list = async (): Promise<SFTP[]> => {
    try {
        const listResult = await fetch(BASE_SERVICE_URL + `/sftp/list`, {
            credentials: 'same-origin',
        }).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                var error = new Error(response.statusText);
                error.response = response;
                throw error;
            }
        }) as SFTP[]
        return listResult;
    } catch (error) {
        return []
    }
}



export default list